export default __webpack_public_path__ + "static/media/screen_livechat_06.481a221b.png";